import { css } from '@emotion/react';

import { zIndex } from 'shared/config';
import COLORS from 'shared/styles/colors';
import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export default css({
  '&.file-search': {
    alignItems: 'center',
    flexDirection: 'column',
    [mediaquery.md]: {
      flexDirection: 'row',
    },
  },
  '.file-search': {
    '&__search-bar': {
      position: 'relative',
      alignItems: 'center',
      flexGrow: 1,
      width: '100%',
      marginBottom: theme.space[4],
      [mediaquery.md]: {
        marginBottom: 0,
        marginRight: theme.space[4],
      },
    },
    '&__icon': {
      position: 'absolute',
      left: '10px',
      zIndex: zIndex.zForeground,
      top: '10px',
      margin: 0,
    },
    '&__spinner': {
      position: 'absolute',
      right: '10px',
      zIndex: zIndex.zForeground,
      top: '12px',
      color: COLORS.NEUTRAL700,
    },
    '&__search-input': {
      width: '100%',
      margin: 0,
      flexGrow: 1,
      '& input': {
        paddingLeft: '40px',
        margin: 0,
        borderRadius: '4px',
      },
    },
    '&__search-btn': {
      margin: 0,
    },
    '&__display-toggle-btn': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '42px',
      borderRadius: '4px',
      [mediaquery.md]: {
        width: 'max-content',
      },
      '& svg': {
        color: COLORS.NEUTRAL500,
      },
    },
  },
});

export const contentStyles = {
  '&.file-search__popover-content-wrapper': {
    padding: theme.space[4],
    height: 'max-content',
  },
  '&.file-search__popover-content-wrapper--marketer': {
    minHeight: '360px',
  },
};
